import styled from 'foundations-theming/utils';
import { OptionValueType } from './CommonMessageHeaderPopoverList';
import { DuplicateIcon } from 'foundations-assets';
import { copyWithFloatingMessage } from '../util/copyToClipboard';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { usageTracker } from '../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../usage-tracker/trackerChannelIdMapping';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WrappingDatum = styled.div.withConfig({
  displayName: "CommonMessageHeaderPopoverListItemDescription__WrappingDatum",
  componentId: "sc-19jcyf9-0"
})(["overflow-wrap:break-word;"]);
const CommonMessageHeaderPopoverListItemDescription = ({
  name,
  displayName,
  value,
  valueType,
  copiableValue,
  genericChannelId
}) => {
  let copyMessages;
  switch (valueType) {
    case OptionValueType.Email:
      {
        copyMessages = {
          copy: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copyEmail`
          }),
          copied: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copiedEmail`
          })
        };
        break;
      }
    case OptionValueType.PhoneNumber:
      {
        copyMessages = {
          copy: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copyPhoneNumber`
          }),
          copied: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copiedPhoneNumber`
          })
        };
        break;
      }
    default:
      {
        copyMessages = {
          copy: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copy`
          }),
          copied: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copied`
          })
        };
        break;
      }
  }
  return /*#__PURE__*/_jsxs(WrappingDatum, {
    children: [name && /*#__PURE__*/_jsxs("b", {
      children: [name, " "]
    }), displayName || '', " ", value, copiableValue ? /*#__PURE__*/_jsx(Tooltip, {
      title: copyMessages.copy,
      children: /*#__PURE__*/_jsx(IconButton, {
        use: "transparent",
        size: "extra-small",
        onClick: () => {
          copyWithFloatingMessage(copiableValue, copyMessages.copied);
          usageTracker.track('copy-contact', {
            action: 'copy contact',
            channel: getUsageTrackingChannel(genericChannelId)
          });
        },
        children: /*#__PURE__*/_jsx(DuplicateIcon, {
          size: "200"
        })
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};
CommonMessageHeaderPopoverListItemDescription.displayName = 'CommonMessageHeaderPopoverListItemDescription';
export default CommonMessageHeaderPopoverListItemDescription;